<template>
  <div class="sm-sort">
  <div class="sm-sort__text">Сортировка:</div>
    <multiselect
        v-model="currentOption"
        :options="options"
        :placeholder="currentOption.label"
        track-by="name"
        label="label"
        @open="this.sendSortOpenEventOption"
        @select="this.setSortOption"
    ></multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import {mapState, mapActions} from 'vuex';

export default {
  name: "sort",
  data () {
    return {
      currentOption: [],
      options: [
          { label: 'По популярности', name: 'default'},
          { label: 'Сначала дешевле', name: 'price_asc' },
          { label: 'Сначала дороже', name: 'price_desc'}
      ]
    }
  },
  computed: {
    ...mapState("search", ["sort"])
  },
  watch: {
    sort: function (e) {
      this.currentOption = this.getOption(e);
    }
  },
  methods: {
    ...mapActions("search", [
      "sendSortSelectEvent",
      "renderInstantSearch",
      "sendSortOpenEvent",
      "setSort",
      "setPagination"
    ]),
    setSortOption: function (e) {
      this.setSort(e.name)
          this.sendSortSelectEvent();
    },
    getOption: function (e) {
      return this.options.find(function (t) {
        return t.name === e;
      });
    },
    sendSortOpenEventOption: function () {
      this.sendSortOpenEvent();
    },
  },
  created: function () {
    const e = this.options[0];
    this.currentOption = this.getOption(e.name);
  },
  components: {
    Multiselect
  }
}
</script>